import React, { Component } from 'react';
import update from 'immutability-helper';
import 'react-rangeslider/lib/index.css'
import Loading from '../Loading.js'
import NamezzzSlider from '../../Fields/NamezzzSlider.js'
import NamezzzLanguage from '../../Fields/NamezzzLanguage.js'
import NamezzzSkill from '../../Fields/NamezzzSkill.js'
import NamezzzLanguageValue from '../../Fields/NamezzzLanguageValue.js'

import { getJobLanguages, postJobLanguages, deleteJobLanguages, postJobSkills, deleteJobSkills, getJobSkills, postJobCompetences, getJobCompetences } from '../../Api/UserActions.js'
import { getJsonItem, getJsonItemInvariantCase } from '../../Utilities/JsonFunctions.js'
import { getTranslation } from '../../Utilities/GetTranslation.js'

declare var globalSns;

class Capabilities extends Component {
    constructor(props) {
        super(props);

        this.state = {
            slide1: 0,
            slide2: 0,
            inputLanguage: "",
            inputSkill: ""
        }

        this.handleSlideChange = this.handleSlideChange.bind(this);
        this.onLanguageSliderChange = this.onLanguageSliderChange.bind(this);
        this.onLanguageDelete = this.onLanguageDelete.bind(this);
        this.onLanguageValueChange = this.onLanguageValueChange.bind(this);  
        this.onSkillSliderChange = this.onSkillSliderChange.bind(this);
        this.onSkillDelete = this.onSkillDelete.bind(this);
        this.onCompetenceSliderChange = this.onCompetenceSliderChange.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.onSkillChange = this.onSkillChange.bind(this);
        this.addLanguage = this.addLanguage.bind(this);   
        this.addSkill = this.addSkill.bind(this);   

        this.languageTimeoutId = []; // Autosave timeout
        this.skillTimeoutId = []; // Autosave timeout
        this.competenceTimeoutId = []; // Autosave timeout
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getJobLanguages(globalSns.jobId, globalSns.languageId, (data) => {
            this.setState({
                jobLanguages: data
            });
        });
        getJobSkills(globalSns.jobId, globalSns.languageId, (data) => {
            this.setState({
                jobSkills: data
            });
        });
        getJobCompetences(globalSns.jobId, globalSns.languageId, (data) => {
            this.setState({
                jobCompetences: data
            });
        });
    }

    saveData(data) {
        //postQuestion(this, data.seqJob, data.seqQuest, data.answer);
    }

    handleSlideChange(id, e) {
        this.setState({
            [id] : e
        });
    }

    handleValueChange(e) {
        this.setState({
            [e.target.id] : e.target.value
        });
    }

    onSkillChange(e, id, synonymId) {
        this.setState({
            inputSkill: e.target.value,
            inputSkillId: id,
            inputSkillSynonymId: synonymId
        })
    }

    onSkillSliderChange(id, e) {
        var idType = id.toString().substring(0, 1);
        var idKey = id.toString().substring(1);

        var item = (idType === "U") ? getJsonItem(this.state.jobSkills, "skillId", idKey) : getJsonItem(this.state.jobSkills, "id", idKey);
        var index = this.state.jobSkills.indexOf(item);

        this.setState({
            jobSkills: update(this.state.jobSkills, {[index]: {score: {$set: e}}})
        })

        // AutoSave with timeout to 
        if (this.skillTimeoutId[idKey] != null) {
            clearTimeout(this.skillTimeoutId[idKey]);
        }
        var _this = this;
        this.skillTimeoutId[idKey] = setTimeout(function() {
            item = (idType === "U") ? getJsonItem(_this.state.jobSkills, "skillId", idKey) : getJsonItem(_this.state.jobSkills, "id", idKey);
            index = _this.state.jobSkills.indexOf(item);
            postJobSkills(item.id, item.skillId, item.synonymId, item.skillText, item.score, globalSns.jobId, (newData) => {
                if (newData.id === item.id) {
                    return;
                }

                newData.name = item.skillText;
                newData.candelete = item.candelete;

                // New Skill history
                _this.setState({
                    jobSkills: update(_this.state.jobSkills, {[index]: {$set: newData}})
                });
            })
        }, 3000)
    }

    addSkill(e) {
        // not selected skill
        if (this.state.inputSkill.trim() === "") {
            return;
        }

        // skill already added
        var item = getJsonItemInvariantCase(this.state.jobSkills, "skillText", this.state.inputSkill);
        if (item != null) {
            return;
        }

        var skillText = this.state.inputSkill;

        postJobSkills(null, this.state.inputSkillId, this.state.inputSkillSynonymId, skillText, 0, globalSns.jobId, (newData) => {
            newData.skillText = skillText;
            newData.candelete = true;

            this.setState({
                jobSkills: update(this.state.jobSkills, {$push: [newData]})
            });
        });

        this.setState({
            inputSkill: "",
            inputSkillId: null,
            inputSkillSynonymId: null
        });
    }

    onSkillDelete(id, e) {
        var idKey = id.toString().substring(1);

        var item = getJsonItem(this.state.jobSkills, "id", idKey);
        
        var skillId = item.skillId;
        var skillText = item.skillText;

        deleteJobSkills(skillId, skillText, () => {
            var index = this.state.jobSkills.indexOf(item);

            this.setState({
                jobSkills: update(this.state.jobSkills, {$splice: [[index, 1]]})
            })
        });
    }

    onCompetenceSliderChange(id, e) {
        var item = getJsonItem(this.state.jobCompetences, "id", id);
        var index = this.state.jobCompetences.indexOf(item);

        this.setState({
            jobCompetences: update(this.state.jobCompetences, {[index]: {score: {$set: e}}})
        })

        // AutoSave with timeout to 
        if (this.competenceTimeoutId[id] != null) {
            clearTimeout(this.competenceTimeoutId[id]);
        }
        var _this = this;
        this.competenceTimeoutId[id] = setTimeout(function() {
            item = getJsonItem(_this.state.jobCompetences, "id", id);
            index = _this.state.jobCompetences.indexOf(item);
            postJobCompetences(globalSns.jobId, item.id, item.name, item.score, item.seqPersComp, (newData) => {
                if (newData.seqPersComp === item.seqPersComp) {
                    return;
                }
    
                newData.name = item.name;
    
                // New Competence history
                _this.setState({
                    jobCompetences: update(_this.state.jobCompetences, {[index]: {$set: newData}})
                });                
            });
        }, 3000)
    }    

    onLanguageValueChange(e, languageId) {
        
        this.setState({
            inputLanguage: e.target.value,
            inputLanguageId: languageId
        });
    }

    onLanguageSliderChange(id, type, e) {
        var item = getJsonItem(this.state.jobLanguages, "id", id);
        var index = this.state.jobLanguages.indexOf(item);

        this.setState({
            jobLanguages: update(this.state.jobLanguages, {[index]: {[type]: {$set: e}}})
        });

        // AutoSave with timeout to 
        if (this.languageTimeoutId[id] != null) {
            clearTimeout(this.languageTimeoutId[id]);
        }
        var _this = this;
        this.languageTimeoutId[id] = setTimeout(function() {
            item = getJsonItem(_this.state.jobLanguages, "id", id);
            index = _this.state.jobLanguages.indexOf(item);
            postJobLanguages(globalSns.jobId, id, item.name, item.candelete, item.talk, item.read, item.write, item.seqPersLang, (newData) => {
                if (newData.seqPersLang === item.seqPersLang) {
                    return;
                }
    
                newData.name = item.name;
                newData.candelete = item.candelete;
        
                // New language history
                _this.setState({
                    jobLanguages: update(_this.state.jobLanguages, {[index]: {$set: newData}})
                });                
            });

        }, 3000)
    }

    addLanguage() {
        // not selected language
        if (this.state.inputLanguageId == null) {
            return;
        }

        // language already added
        var item = getJsonItem(this.state.jobLanguages, "id", this.state.inputLanguageId);
        if (item != null) {
            return;
        }
        
        var name = this.state.inputLanguage;

        postJobLanguages(globalSns.jobId, this.state.inputLanguageId, this.state.inputLanguage, true, 0, 0, 0, 0, (newData) => {            
            newData.name = name;
            newData.candelete = true;

            this.setState({
                jobLanguages: update(this.state.jobLanguages, {$push: [newData]})
            })
        });

        this.setState({
            inputLanguage: "",
            inputLanguageId: null
        })

    }

    onLanguageDelete(id, e) {
        deleteJobLanguages(id, () => {
            var item = getJsonItem(this.state.jobLanguages, "id", id);
            var index = this.state.jobLanguages.indexOf(item);

            this.setState({
                jobLanguages: update(this.state.jobLanguages, {$splice: [[index, 1]]})
            })
        });
    }

    render() {
        
        if (this.state.jobLanguages == null || this.state.jobSkills == null || this.state.jobCompetences == null) {
            return (
                <Loading/>
            );
        }
      
        return (
            <div>
                <div>
                    <h4 className="legend-title">{getTranslation("sns.webparts.capabilities.languages")}</h4>
                    <p><em>{getTranslation("sns.webparts.capabilities.languages.sub")}</em></p>
                    <div className="tr">
                        <NamezzzLanguageValue id="inputLanguage" seqlang={globalSns.languageId} value={this.state.inputLanguage} onChange={this.onLanguageValueChange} onEnter={this.addLanguage} />
                        <div className="td">
                            <input type="button" className="FormButton btn btn-primary blue act" value={getTranslation("sns.webparts.capabilities.addlanguage")} onClick={this.addLanguage} />
                        </div>
                    </div>
                
                    <h5>{getTranslation("sns.webparts.capabilities.languages.selected")}</h5>
                    <ul className="languages" id="languages">
                        {
                            this.state.jobLanguages.map((language) =>
                                <NamezzzLanguage key={language.id} id={language.id} language={language.name} talk={language.talk} read={language.read} write={language.write} delete={language.candelete}
                                        onLanguageChange={this.onLanguageSliderChange} onLanguageDelete={this.onLanguageDelete} />  
                            )
                        }
                    </ul>
                </div>

                <div>
                    <h4 className="legend-title">{getTranslation("sns.webparts.capabilities.skills")}</h4>
                    <p><em>{getTranslation("sns.webparts.capabilities.skills.sub")}</em></p>
                    <div className="tr">
                        <NamezzzSkill id="inputSkill" seqlang={globalSns.languageId} value={this.state.inputSkill} onChange={this.onSkillChange} onEnter={this.addSkill} />
                        <div className="td">
                            <input type="button" className="FormButton btn btn-primary blue act" value={getTranslation("sns.webparts.capabilities.addskill")} onClick={this.addSkill} />
                        </div>
                    </div>
                    
                    <h5>{getTranslation("sns.webparts.capabilities.skills.selected")}</h5>
                    <ul className="sliders" id="skills">
                        {
                            this.state.jobSkills.map((skill) => {
                                var id = (skill.id == null) ? "U" + skill.skillId : "R" + skill.id;
                                return <NamezzzSlider key={id} id={id} text={skill.skillText} delete={skill.candelete} value={skill.score} onChange={this.onSkillSliderChange} onDelete={this.onSkillDelete} />
                            })
                        }
                    </ul>
                </div>

                {
                    (this.state.jobCompetences.length > 0) ?
                        <div>
                            <h4 className="legend-title">{getTranslation("sns.webparts.capabilities.competences")}</h4>
                            <p><em>{getTranslation("sns.webparts.capabilities.competences.sub")}</em></p>
                            <h5>{getTranslation("sns.webparts.capabilities.competences.selected")}</h5>
                            <ul className="sliders" id="competences">
                                {
                                    this.state.jobCompetences.map((compentence) =>
                                        <NamezzzSlider key={compentence.id} id={compentence.id} text={compentence.name} delete={false} value={compentence.score} onChange={this.onCompetenceSliderChange} />
                                    )
                                }
                            </ul> 
                        </div>: ""
                }
            </div>
        );
    }
}

export default Capabilities;


// WEBPACK FOOTER //
// ./src/Components/Tabs/Capabilities.js